import { render, staticRenderFns } from "./ApproveDialog.vue?vue&type=template&id=6753c31d&"
import script from "./ApproveDialog.vue?vue&type=script&lang=js&"
export * from "./ApproveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports